import { useEffect } from "react";

interface GoogleTagLoaderProps {
  tagId: string | null;
}

const isValidTagId = (id: string): boolean =>
  /^(GTM-[A-Z0-9]{4,10}|G-[A-Z0-9]{4,15}|UA-\d{4,10}-\d{1,4}|AW-\d{6,12}|DC-\d{6,12})$/.test(id);

const GoogleTagLoader = ({ tagId }: GoogleTagLoaderProps) => {
  useEffect(() => {
    if (!tagId) return;
    if (!isValidTagId(tagId)) {
      console.warn("Invalid Google Tag ID format; refusing to load.");
      return;
    }

    // Check if script already exists
    const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${tagId}"]`);
    if (existingScript) return;

    // Add gtag script (tagId validated against strict regex above)
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(tagId)}`;
    document.head.appendChild(script);

    // Initialize dataLayer — JSON.stringify safely encodes the tagId
    const inlineScript = document.createElement("script");
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', ${JSON.stringify(tagId)});
    `;
    document.head.appendChild(inlineScript);

    return () => {
      // Cleanup on unmount (optional, as tags usually persist)
    };
  }, [tagId]);

  return null;
};

export default GoogleTagLoader;
